module.exports = __webpack_public_path__ + "static/media/success_icon.e505f8af.svg";